<div class="pr-tainer devices-page">
    <div class="container">
        <div class="header-row">
            <div>
                <h3 class="page-title">Add Device</h3>
                <p class="section-desc">Devices are a way to manage and assign equipment based on patient needs.</p>
            </div>
            <button class="fab" *ngIf="showAddDeviceFab" (click)="addDevice()"><span>+</span></button>
        </div>
    </div>

    <!-- Add/Edit Device Modal -->
    <div class="modal-backdrop" *ngIf="showAddDeviceModal || showEditDeviceModal">
        <div class="modal add-device-modal">
            <div class="modal-header">
                <span class="modal-title">{{ showEditDeviceModal ? 'Edit Device' : 'Add Device' }}</span>
                <button class="modal-close"
                    (click)="showEditDeviceModal ? closeEditDeviceModal() : closeAddDeviceModal()">&times;</button>
            </div>

            <div class="modal-body">
                <form (ngSubmit)="showEditDeviceModal ? saveDeviceEdit() : saveNewDevice()">

                      <!-- Device Name -->
                    <div class="modal-form-row">
                        <label>*Device Name</label>
                        <input type="text" maxlength="100" [(ngModel)]="deviceToEdit.deviceName" name="deviceName"
                            required />
                    </div>

                    <!-- Serial Number -->
                    <div class="modal-form-row">
                        <label>*Serial Number</label>
                        <input type="text" maxlength="50" [(ngModel)]="deviceToEdit.serialNumber"
                            name="deviceSerialNumber" required />
                    </div>

                </form>
            </div>

            <div class="modal-footer">
                <button class="modal-cancel"
                    (click)="showEditDeviceModal ? closeEditDeviceModal() : closeAddDeviceModal()">Cancel</button>
                <button class="modal-save"
                    (click)="showEditDeviceModal ? saveDeviceEdit() : saveNewDevice()">Save</button>
            </div>
        </div>
    </div>
</div>